export function smtpSetupForm() {
  const names = [
    { name: "smtpName", placeHolder: 'smtpNamePlaceHolder' },
    { name: "smtpHost", placeHolder: 'smtpHostPlaceHolder' },
    { name: "smtpPort", placeHolder: 'smtpPortPlaceHolder' },
    { name: "smtpEmail", placeHolder: 'smtpEmailPlaceHolder' },
    { name: "smtpSender", placeHolder: 'smtpSenderPlaceHolder' },
    { name: "smtpSenderEmail", placeHolder: 'smtpSenderEmailPlaceHolder' },
    { name: "smtpPassword", placeHolder: 'smtpPasswordPlaceHolder' }
  ];
  return names;
}